import { request } from '../request';

export function resendOtp(email: string) {
  return request.get('/v2/identity/login-otp', {
    params: {
      email,
    },
  });
}
